/**
 * ArrowUpIcon — sanitized from `assets/newSvg/arrow-up.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function ArrowUpIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M10.9393,7.93932 C11.5251,7.35354 12.4749,7.35354 13.0607,7.93932 L18.7175,13.5962 C19.3033,14.182 19.3033,15.1317 18.7175,15.7175 C18.1317,16.3033 17.182,16.3033 16.5962,15.7175 L12,11.1213 L7.40381,15.7175 C6.81802,16.3033 5.86827,16.3033 5.28248,15.7175 C4.6967,15.1317 4.6967,14.182 5.28249,13.5962 L10.9393,7.93932 Z"
        fill={color}
      />
    </Svg>
  );
}

export default ArrowUpIcon;
